
<template>
    <el-dialog title="分配权限" :visible.sync="dialogRole">
       <el-tree class="filter-tree" :data="treeData" :default-checked-keys="checkedKeys" :check-strictly="false" node-key="id"  highlight-current show-checkbox ref="menuTree" default-expand-all>
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="updatePermession(roleId, roleCode)">更 新
          </el-button>
        </div>
    </el-dialog>
</template>
<script>
 import {fetchRoleTree,permissionUpd,findMenuByRole} from '@/api/admin/role'
import {fetchTree} from '@/api/admin/menu'
import {formatSelectTree,dealElement} from '@/util/util'
import waves from '@/directive/waves/index.js' // 水波纹指令
import {objKeySort} from '@/util/ajaxsign'
import {phone,email,validatePass,validatePass2} from "@/util/Format"
export default {
    name: 'table_user',
    directives: {
        waves
    },
    data() {
        return {
            treeData : [],
            checkedKeys: [],
            menuIds : [],
            roleName : '',
            dialogRole : false,
            obj : {},
            rules : {},
        }
    },
    created() {},
    methods: {
        //展示弹出层
        dialog(roleid,roleName){
            this.dialogRole = true;
            this.roleName = roleName;
            this.roleId = roleid;
            this.setRole(roleName);
        },

        setRole(data){
            this.checkedKeys.length = 0;
            findMenuByRole(objKeySort(),this.roleId).then(response => {
                for(var i=0;i<response.data.length;i++){
                    this.checkedKeys.push(response.data[i].menuId)
                }
                //this.checkedKeys = response.data;
                return fetchTree(objKeySort({}))
            })    
            .then(response => {
                this.treeData = response.data;
                this.checkedKeys = this.resolveAllLeafNodeId(this.treeData, this.checkedKeys, []);
            })
        },

         // 更新权限
        updatePermession() {
            this.menuIds = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys())
           permissionUpd(objKeySort({roleId:this.roleId,menuIds:this.menuIds})).then(response => {
                this.checkedKeys = response.data;
                this.$emit('refresh','');
                this.handleEmpty();
                this.$message({
                    title: '成功',
                    message: '修改成功',
                    type: 'success',
                    duration: 2000
                })
            })
        },


        /**
         * 解析出所有的叶子节点id
         * @param json 待解析的json串
         * @param idArr 原始节点数组
         * @param temp 临时存放节点id的数组
         * @return 叶子节点id数组
       */
        resolveAllLeafNodeId(json, idArr, temp) {
            for (let i = 0; i < json.length; i++) {
                const item = json[i]
                // 存在子节点，递归遍历;不存在子节点，将json的id添加到临时数组中
                if (item.children && item.children.length !== 0) {
                    this.resolveAllLeafNodeId(item.children, idArr, temp)
                } else {
                    temp.push(idArr.filter(id => id === item.id))
                }
            }
            return temp
        },

        handleEmpty(){
            this.dialogRole = false;
        },

    }
}
</script>